import { GlAvatar, GlLink, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import LinkCell from '../../../runner/components/cells/link_cell.vue?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
export default {
    name: 'PipelineCell',
    i18n: {
        stageLabel: s__('Jobs|Stage')
    },
    components: {
        GlAvatar,
        GlLink,
        LinkCell
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        job: {
            type: Object,
            required: true
        }
    },
    computed: {
        pipelineId () {
            const id = getIdFromGraphQLId(this.job.pipeline.id);
            return `#${id}`;
        },
        pipelinePath () {
            return this.job.pipeline?.path;
        },
        pipelineUserAvatar () {
            return this.job.pipeline?.user?.avatarUrl;
        },
        userPath () {
            return this.job.pipeline?.user?.webPath;
        },
        showAvatar () {
            return this.job.pipeline?.user;
        },
        pipelineUserName () {
            return this.job.pipeline?.user?.name;
        }
    }
};
